export const getFirstElement = data => {
  let text = '';
  if (data && data.length > 0) {
    text = data[0].description;
  }
  return text;
};
